// extracted by mini-css-extract-plugin
export default {"cardBox":"styles_cardBox__9y-tI","cardBoxSm":"styles_cardBoxSm__0QZBj","cardBoxMd":"styles_cardBoxMd__VAQfP","Lg":"styles_Lg__0bCfN"};